export default __webpack_public_path__ + "img/woman-oppresses-shapes.bad3290.svg";